import * as classroomApi from "./classroomApi";

export interface ClassroomPersonalisationRequest {
	classroomId: string;
	pinned: boolean | undefined;
	displayName: string | undefined;
	studentSortOrder: "firstNameAscending" | "lastNameAscending";
}

export const setClassroomPersonalisation = async (
	teacherStableIdV1: string,
	classroomStableIdV1: string,
	pinned: boolean | undefined,
	displayName: string | undefined,
	studentSortOrder: "firstNameAscending" | "lastNameAscending" | "" | undefined
): Promise<object> => {
	const payloadSortOrder = studentSortOrder === "lastNameAscending" ? "lastNameAscending" : "firstNameAscending";
	const payload: ClassroomPersonalisationRequest = {
		classroomId: classroomStableIdV1,
		pinned,
		displayName,
		studentSortOrder: payloadSortOrder,
	};

	return await classroomApi.Post2(`v1/teachers/${teacherStableIdV1}/personalisation`, payload);
};

export interface CreateStudentPersonalisationRequest {
	studentId: string;
	pinned: boolean;
}

export const setStudentPersonalisation: (
	teacherStableIdV1: string,
	classroomStableIdV1: string,
	studentId: string,
	pinned: boolean
) => Promise<unknown> = async (teacherStableIdV1, classroomStableIdV1, studentId, pinned) => {
	const endpoint = `v1/teachers/${teacherStableIdV1}/classrooms/${classroomStableIdV1}/student-personalisation`;
	const body: CreateStudentPersonalisationRequest = {
		studentId,
		pinned,
	};

	return await classroomApi.Put2(endpoint, body);
};
